import { render } from "./DragDropFileUpload.vue?vue&type=template&id=040539b6&scoped=true"
import script from "./DragDropFileUpload.vue?vue&type=script&lang=js"
export * from "./DragDropFileUpload.vue?vue&type=script&lang=js"

import "./DragDropFileUpload.vue?vue&type=style&index=0&id=040539b6&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040539b6"]])

export default __exports__